import { defineStore } from 'pinia'
import type { ErpSparePart } from '~/types/part'

interface SparepartState {
  currentSparepart: ErpSparePart[] | null
}

export const useSparepartStore = defineStore('sparepart', {
  state: (): SparepartState => ({
    currentSparepart: null
  }),

  getters: {
    getCurrentSpareparts: state => state.currentSparepart
  },

  actions: {
    async fetchSpareparts(sku: string): Promise<ErpSparePart[] | null> {
      const { getSpareParts } = useSparePart()
      this.currentSparepart = await getSpareParts(sku)

      return this.currentSparepart
    }
  }
})
